import React, { useMemo, Fragment, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import IconButton from '@mui/material/IconButton';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from '@mui/material/Box';
import ClientAccStandardPDTitleChangeDialog from "./ClientAccStandardPDTitleChangeDialog";
import MpgConfirmDialog from "../../../../../common/dialog/MpgConfirmDialog";
import ClientAccCustomPDTitleChangeDialog from "./ClientAccCustomPDTitleChangeDialog";
import {useOutletContext } from "react-router-dom";

const ClientAccPDDataTable = ({ tableData, setTableData }) => {

    const [realTableData, setRealTableData] = useState([])
    useEffect(() => {
        if (!!tableData && !!tableData?.length) {

            const list = []
            tableData.forEach((item) => {
                if (item?.ProgramDescripitorType === "Customized") {
                    if (!item?.TobeDeleted) {
                        list.push(item)
                    }
                } else {
                    list.push(item)
                }
            })
            setRealTableData(list)
        } else {
            setRealTableData([])
        }
    }, [tableData])

    // console.log("table-realTableData", realTableData)
    // console.log("table-TableData", tableData)

    const [openClientAccStandardPDTitleChangeDialog, setOpenClientAccStandardPDTitleChangeDialog] = useState(false)

    const [openClientAccCustomPDTitleChangeDialog, setOpenClientAccCustomPDTitleChangeDialog] = useState(false)

    const resourcesCMSData = useOutletContext();
  
    const fetchMngResRepoListLabel = (key) => {
        //console.log(resourcesCMSDataLabel);
        if (resourcesCMSData && resourcesCMSData?.pageContent["ManageResourceRepoList"]) {
            const resourcesCMSDataLabel = resourcesCMSData.pageContent["ManageResourceRepoList"];
            return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
        const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
        return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    const [selectedDataObj, setSelectedDataObj] = useState({})

    const columns = useMemo(
        () => [
            {
                accessorKey: "clientAccPDTitle",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientResourceTitle') , //"Client-Resource Title",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ClientAccountResourcesList.") }
            },
            {
                accessorKey: "ProgramDescripitorTitle",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceTitle') , //"Resource Title",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ManageResourceRepoList.PlaceholderResourceTitle")}
            },
            {
                accessorKey: "ProgramDescripitorFileName",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceFileName') , //"Resource File Name",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ManageResourceRepoList.PlaceholderResourceFileName") }
            },
            {
                accessorKey: "ProgramDescripitorType",
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceType') , //"Resource Type",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ClientAccountResourcesList") }
            },
            {
                accessorFn: (originalRow) => {
                    const val = originalRow.IsActive
                    return !!val ? "Active" : "Inactive"
                }, //must be strings
                id: 'isActive',
                header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.Status') , //"Status",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchMngResRepoListLabel ("ClientAccountResourcesList") }
            },
        ],
        [resourcesCMSData],
    );

    /**confirm dialog state on remove action */
    const [openMpgConfirmDialog, setOpenMpgConfirmDialog] = useState(false)
    const [idTobeRemoved, setIdTobeRemoved] = useState("")

    return (
        <Fragment>
            <MaterialReactTable
                columns={columns}
                data={realTableData || []}
                enableGlobalFilter={false}
                enableDensityToggle={false}

                enableTopToolbar={!!realTableData && realTableData.length ? true : false}
                enableBottomToolbar={!!realTableData && realTableData.length ? true : false}
                initialState={{
                    density: 'compact'
                }}

                enableRowActions
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                      header: fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.Actions'), //Actions
                    },
                  }}
                  muiTablePaginationProps={{
                    labelRowsPerPage: fetchCommonCMSLabel('Common.Rowsperpage') //Rows per page
                  }}

                renderRowActions={({ row, table }) => {
                    const Id = row.original?.Id;
                    const clientAccPDTitle = row.original?.clientAccPDTitle;
                    const ProgramDescripitorTitle = row.original?.ProgramDescripitorTitle;
                    const ProgramDescripitorFileName = row.original?.ProgramDescripitorFileName;
                    const ProgramDescripitorType = row.original?.ProgramDescripitorType;


                    return (
                        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                            {/**edit action */}
                            <IconButton
                                onClick={() => {
                                    setSelectedDataObj({
                                        Id,
                                        clientAccPDTitle,
                                        ProgramDescripitorTitle,
                                        ProgramDescripitorFileName,
                                        ProgramDescripitorType
                                    })

                                    if (ProgramDescripitorType === "Customized") {
                                        setOpenClientAccCustomPDTitleChangeDialog(true)
                                        setOpenClientAccStandardPDTitleChangeDialog(false)
                                    }
                                    else {
                                        setOpenClientAccCustomPDTitleChangeDialog(false)
                                        setOpenClientAccStandardPDTitleChangeDialog(true)
                                    }

                                }}
                            >
                                <EditIcon />
                            </IconButton>

                            {/**delete action */}
                            <IconButton
                                onClick={() => {
                                    setIdTobeRemoved(Id)
                                    setOpenMpgConfirmDialog(true)
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>


                        </Box>
                    )
                }}
            />

            <ClientAccStandardPDTitleChangeDialog
                open={openClientAccStandardPDTitleChangeDialog}
                setOpen={setOpenClientAccStandardPDTitleChangeDialog}
                selectedDataObj={selectedDataObj}
                tableData={tableData}
                setTableData={setTableData}
            />

            <ClientAccCustomPDTitleChangeDialog
                open={openClientAccCustomPDTitleChangeDialog}
                setOpen={setOpenClientAccCustomPDTitleChangeDialog}
                selectedDataObj={selectedDataObj}
                tableData={tableData}
                setTableData={setTableData}
            />

            {/** confirm dialog on delete action */}
            <MpgConfirmDialog
                //title={`Confirm your action.`}
                title={fetchCommonCMSLabel('Common.ConfirmYourAction')}
                //content={`Are you sure you want to remove this entry.`}
                content={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.DeleteConfirmationMsg')}
                open={openMpgConfirmDialog}
                setOpen={setOpenMpgConfirmDialog}
                extraLogicHandlerOnAgree={() => {

                    const modifiedData = []
                    !!tableData && tableData.forEach((eachItem) => {

                        if (eachItem?.ProgramDescripitorType === "Customized" && eachItem?.Id === idTobeRemoved) {
                            modifiedData.push({
                                ...eachItem,
                                TobeDeleted: true
                            })
                        } else {
                            if (eachItem.Id !== idTobeRemoved) {
                                modifiedData.push(eachItem)
                            }
                        }
                    })

                    console.log("modifiedData", modifiedData)
                    // const filteredArray = !!tableData && tableData.filter((eachItem) => {
                    //     if (eachItem.Id !== idTobeRemoved) {
                    //         return eachItem
                    //     }
                    // })
                    setTableData(modifiedData)

                    setIdTobeRemoved('')
                }}
            />
        </Fragment>
    )
}
export default ClientAccPDDataTable